import React from "react";

export const Citygml2kml = () => {


  return (
    <>
      <div className="absolute z-30 font-mono text-black w-full h-screen bg-blue-100">
        あああ
      </div>
    </>
  );
};
